import { ref } from "vue";
import { defineStore } from "pinia";
import { usePromiseWrapper } from "@/hooks/common";
import applicationsApiService from "@/services/modules/applications";
import type { AiSearchDeal } from "@/models/cmdK";

export const useAiSearchStore = defineStore("aiSearch", () => {
  const dealResults = ref<AiSearchDeal[] | null>(null);
  const { fetchWrapper: aiSearchDeals, loading: aiSearchDealsLoading } =
    usePromiseWrapper(
      async (phrase: string, filters?: Record<string, unknown>) => {
        const response = await applicationsApiService.aiSearchApplications(
          phrase,
          filters
        );
        dealResults.value = response.data;
      }
    );

  return {
    dealResults,
    aiSearchDeals,
    aiSearchDealsLoading
  };
});
